module.exports = __webpack_public_path__ + "img/florina-2021-black.3f0cd618.png";